module.exports = __webpack_public_path__ + "static/media/(000110).d155ce60.jpg";